exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, ".list[data-v-8ad71c2c]{width:100%;padding:0}", "", {"version":3,"sources":["/Users/markryan/develop/personal/fresh-start/src/components/members/settingsView.vue"],"names":[],"mappings":"AACA,uBACE,WAAY,AACZ,SAAW,CACZ","file":"settingsView.vue","sourcesContent":["\n.list[data-v-8ad71c2c] {\n  width: 100%;\n  padding: 0;\n}\n"],"sourceRoot":""}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"minimize":true,"sourceMap":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-8ad71c2c","scoped":true,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/members/settingsView.vue
// module id = 646
// module chunks = 13